/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Interval_Every_DaysInputs */

const en_plan_interval_every_days = /** @type {(inputs: Plan_Interval_Every_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} days`)
};

const es_plan_interval_every_days = /** @type {(inputs: Plan_Interval_Every_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cada ${i?.count} días`)
};

/**
* | output |
* | --- |
* | "Every {count} days" |
*
* @param {Plan_Interval_Every_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_interval_every_days = /** @type {((inputs: Plan_Interval_Every_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Interval_Every_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_interval_every_days(inputs)
	return en_plan_interval_every_days(inputs)
});